import { configApi } from '../http-client.js'

/**
 * Get file loader jobs with date range and type filters
 * @param {Object} params - Query parameters
 * @param {string} [params.fromDate] - Start date (ISO 8601 format)
 * @param {string} [params.toDate] - End date (ISO 8601 format)
 * @param {string} [params.fileType] - Filter by file type ('All' returns all types)
 * @param {string} [params.loadStatus] - Filter by status (success/failed)
 * @returns {Promise}
 */
export const getFileLoaderJobs = (params = {}) => {
	const queryParams = new URLSearchParams()

	// Validate and append fromDate with UTC timezone
	if (params.fromDate && typeof params.fromDate === 'string') {
		// Convert YYYY-MM-DD to UTC midnight: YYYY-MM-DDT00:00:00Z
		const fromDateUtc = params.fromDate.includes('T')
			? params.fromDate
			: `${params.fromDate}T00:00:00Z`
		queryParams.append('fromDate', fromDateUtc)
	}

	// Validate and append toDate with UTC timezone
	if (params.toDate && typeof params.toDate === 'string') {
		// Convert YYYY-MM-DD to UTC end of day with millisecond precision to include sub-second timestamps
		const toDateUtc = params.toDate.includes('T')
			? params.toDate
			: `${params.toDate}T23:59:59.999Z`
		queryParams.append('toDate', toDateUtc)
	}

	// Validate and append fileType (must be non-empty string, skip if 'All')
	if (params.fileType && typeof params.fileType === 'string' && params.fileType !== 'All') {
		queryParams.append('fileType', params.fileType.trim())
	}

	// Validate and append loadStatus (must be 'success' or 'failed')
	if (params.loadStatus && typeof params.loadStatus === 'string') {
		const status = params.loadStatus.toLowerCase()
		if (status === 'success' || status === 'failed') {
			queryParams.append('loadStatus', status)
		}
	}

	const queryString = queryParams.toString()
	return configApi.get(`/api/FileLoader${queryString ? `?${queryString}` : ''}`)
}

/**
 * Get specific file loader job by ID
 * @param {string} id - File loader GUID
 * @returns {Promise}
 */
export const getFileLoaderJob = id => {
	return configApi.get(`/api/FileLoader/${id}`)
}
